import React, {useState} from 'react';
import {Modal} from "antd";
import ImgClose from "@/shared/pictures/close.svg";
import ImgBrokenStick from "@/shared/pictures/broken_stick.png";
import {EmailInput} from "@/shared/ui/EmailInput";
import {useStore} from "@/app/providers/StoreProvider";
import {buyInventoryItem} from "@/shared/api/api";
import {InventoryItemsName} from "@/entities/inventory/types";



export const OviFlexModal = () => {
    const { modalStore, errorStore } = useStore();

    const [email, setEmail] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);


    const buyItem = async () => {
        if (!isEmailValid) return;

        const buyResponse = await buyInventoryItem(InventoryItemsName.OviFlex100,1, email);
        if (buyResponse.success) {
            window.location.href = buyResponse.data.paymentUrl;
        } else {
            errorStore.setError(buyResponse.error);
        }
    }

    return (
        <Modal
            open={true}
            footer={null}
            closeIcon={<img src={ImgClose} onClick={() => modalStore.close()} alt=""/>}
        >
            <div className='modal'>

                <img src={ImgBrokenStick} className='modal_image'
                     alt="" style={{maxWidth: 150}}/>

                <p className='modal_text'>Вы&nbsp;сделали 50&nbsp;бросков, ваша клюшка OVIE
                    FLEX сломалась. Она давала вам x2&nbsp;за&nbsp;попадание. Клюшка
                    станет доступна через 20&nbsp;часов. Хотите ускорить таймер в&nbsp;два
                    раза?</p>

                <EmailInput
                    value={email}
                    onChange={(val, isValid) => {
                        setEmail(val);
                        setIsEmailValid(isValid);
                    }}
                />

                <div className='modal_buttons'>
                    <button type='button' className='modal_button button_blue' onClick={() => buyItem()}>Да, ускорить</button>
                    <p className='modal_text-policy'>Нажимая "Купить" - вы соглашаетесь <br/>с <a
                        href='https://docs.google.com/document/d/169Rsrf_Rw7mLgFuM-8C4LHNrs57pVMgahcAC7FL2lyc'>публичной
                        офертой</a>
                    </p>
                    <button type='button' className='modal_button button_gray'
                            onClick={() => modalStore.close()}>Нет, буду ждать
                    </button>
                </div>

            </div>
        </Modal>
    );
};

